<template>
    <div class="TicketLoadForm">
        <Row>
            <Column :md="6">
                <FormDateTimeInput
                    v-model="$v.loadSiteArriveAt.$model"
                    label="Arrive Load Site"
                    :errors="$v.loadSiteArriveAt.$error ? [
                        !$v.loadSiteArriveAt.required && 'Arrive Load Site is required',
                        !$v.loadSiteArriveAt.minValue && 'Must be after last load\'s Leave Dump Site',
                    ] : null"
                />
            </Column>
            <Column :md="6">
                <FormDateTimeInput
                    v-model="$v.loadSiteLeaveAt.$model"
                    label="Leave Load Site"
                    :errors="$v.loadSiteLeaveAt.$error ? [
                        !$v.loadSiteLeaveAt.required && 'Leave Load Site is required',
                        !$v.loadSiteLeaveAt.minValue && 'Has to be after Arrive Load Site',
                    ] : null"
                />
            </Column>
        </Row>
        <Row>
            <Column :md="6">
                <FormDateTimeInput
                    v-model="$v.dumpSiteArriveAt.$model"
                    label="Arrive Dump Site"
                    :errors="$v.dumpSiteArriveAt.$error ? [
                        !$v.dumpSiteArriveAt.required && 'Arrive Dump Site is required',
                        !$v.dumpSiteArriveAt.minValue && 'Has to be after Leave Load Site',
                    ] : null"
                />
            </Column>
            <Column :md="6">
                <FormDateTimeInput
                    v-model="$v.dumpSiteLeaveAt.$model"
                    label="Leave Dump Site"
                    :errors="$v.dumpSiteLeaveAt.$error ? [
                        !$v.dumpSiteLeaveAt.required && 'Leave Dump Site is required',
                        !$v.dumpSiteLeaveAt.minValue && 'Has to be after Arrive Dump Site',
                    ] : null"
                />
            </Column>
        </Row>
        <Row>
            <Column :md="6">
                <FormDateTimeInput
                    v-model="$v.standbyStartAt.$model"
                    label="Start Standby"
                    :errors="$v.standbyStartAt.$error ? [
                        !$v.standbyStartAt.required && 'Start Standby is required',
                    ] : null"
                />
            </Column>
            <Column :md="6">
                <FormDateTimeInput
                    v-model="$v.standbyEndAt.$model"
                    label="End Standby"
                    :errors="$v.standbyEndAt.$error ? [
                        !$v.standbyEndAt.required && 'End Standby is required',
                        !$v.standbyEndAt.minValue && 'Has to be after Start Standby',
                    ] : null"
                />
            </Column>
        </Row>
        <Row>
            <Column :md="6">
                <FormTonsInput
                    v-model="$v.tons.$model"
                    label="Tons"
                    :errors="$v.tons.$error ? [
                        !$v.tons.required && 'Tons is required',
                    ] : null"
                />
            </Column>
            <Column :md="6">
                <FormSelectMaterial
                    v-model.number="$v.material.$model"
                    :errors="$v.material.$error ? [
                        !$v.material.required && 'Material is required',
                    ] : null"
                />
            </Column>
        </Row>
        <Row>
            <Column :md="6">
                <FormInput
                    v-model="scaleTicketCode"
                    label="Scale Ticket #"
                />
            </Column>
            <Column :md="6">
                <div class="toggleRow">
                    <h4>Backhaul</h4>
                    <FormToggle v-model="isBackhaul"/>
                </div>
            </Column>
        </Row>

        <!-- <strong>Photo</strong>
        <FormImage name="photo"/> -->

        <FormTextarea v-model="notes" label="Load Notes"/>
    </div>
</template>

<script>
import FormSelectMaterial from '@/components/common/FormSelectMaterial';
import { required, minValue, requiredIf } from 'vuelidate/lib/validators';

export default {
    name: 'TicketLoadForm',

    components: { FormSelectMaterial },

    syncProps: [
        'loadSiteArriveAt',
        'loadSiteLeaveAt',
        'dumpSiteArriveAt',
        'dumpSiteLeaveAt',
        'standbyStartAt',
        'standbyEndAt',
        'tons',
        'material',
        'scaleTicketCode',
        'isBackhaul',
        'notes',
    ],

    props: {
        previousLoad: { type: Object, default: null },
    },

    validations: {
        loadSiteArriveAt: {
            required,
            minValue(value) {
                if (!this.previousLoad) return true;
                return value >= this.previousLoad.dumpSiteLeaveAt;
            },
        },
        loadSiteLeaveAt: {
            required,
            minValue(value) {
                return value >= this.loadSiteArriveAt;
            },
        },
        dumpSiteArriveAt: {
            required,
            minValue(value) {
                return value >= this.loadSiteLeaveAt;
            },
        },
        dumpSiteLeaveAt: {
            required,
            minValue(value) {
                return value >= this.dumpSiteArriveAt;
            },
        },
        standbyStartAt: {
            required: requiredIf('standbyEndAt'),
        },
        standbyEndAt: {
            required: requiredIf('standbyStartAt'),
            minValue(value) {
                return value >= this.standbyStartAt;
            },
        },
        tons: {
            required,
        },
        material: {
            required,
        },
    },

    methods: {
        validate() {
            this.$v.$touch();
            return !this.$v.$invalid;
        },
    },
}
</script>

<style lang="scss" scoped>
.TicketLoadForm {
    .toggleRow {
        h4 {
            margin-bottom: 10px;
        }
    }
}
</style>